/* Scroll-responsive photography: bounded depth, no timer loop or wheel/touch interception. */
if (!customElements.get('one-depth-media')) {
  customElements.define('one-depth-media', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.abort?.abort();
      this.abort = new AbortController();
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.paint(); });
      };
      this.motion.addEventListener('change', () => this.observe(), { signal: this.abort.signal });
      this.observe();
    }
    observe() {
      this.observer?.disconnect(); this.stop(); this.reset();
      if (this.motion.matches || navigator.connection?.saveData || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.stop();
        if (!entry.isIntersecting) return;
        this.visible = new AbortController();
        const options = { passive: true, signal: this.visible.signal };
        window.addEventListener('scroll', this.queue, options);
        window.addEventListener('resize', this.queue, options);
        this.queue();
      });
      this.observer.observe(this);
    }
    paint() {
      if (!this.isConnected || this.motion.matches) return;
      const rect = this.getBoundingClientRect();
      const position = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / Math.max(innerHeight / 2, 1)));
      const bottle = this.dataset.depthMode === 'bottle', mobile = this.mobile.matches;
      const lift = mobile ? 5 : bottle ? 18 : 7;
      this.style.setProperty('--one-depth-y', `${(-position * lift).toFixed(2)}px`);
      this.style.setProperty('--one-depth-rotate', `${(bottle && !mobile ? position * 2 : 0).toFixed(2)}deg`);
      this.style.setProperty('--one-depth-x', `${(bottle && !mobile ? -position : 0).toFixed(2)}deg`);
      this.style.setProperty('--one-shadow-scale', (1 - Math.abs(position) * 0.08).toFixed(3));
    }
    stop() {
      this.visible?.abort(); if (this.frame) cancelAnimationFrame(this.frame); this.frame = null;
    }
    reset() { ['--one-depth-y','--one-depth-rotate','--one-depth-x','--one-shadow-scale'].forEach(key => this.style.removeProperty(key)); }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); this.stop(); this.reset(); }
  });
}
